import React from 'react';
import styled from 'styled-components';

const SpinnerContainer = styled.div`
  min-width: 237px;
  min-height: 111px; 
  display: flex;
  justify-content: center;
  padding-top: 27px;
`;

export default SpinnerContainer;
